export default function transfer(list) {
  const tree = [];
  const map = new Map();
  list.forEach((per) => {
    const leaf = {
      children:[],
      id: per.id,
      add_label: per.openStatus === 0 ? `${per.permissionName}(未开通)` : per.permissionName,
      terminalType: per.terminalType,
      isLeaf: true,
      origin: per,
      disabled: per.openStatus === 0,
    };

    // 约定permissionLevel1Name必定有
    const name1 = per.permissionLevel1Name || '其他';
    if (!map.get(name1)) {
      map.set(name1, {
        id: name1,
        add_label: name1,
        children: [],
      });
      tree.push(map.get(name1));
    }
    const level1 = map.get(name1);
    if (!per.permissionLevel2Name) {
      level1.children.push(leaf);
      return;
    }

    const name2 = `${name1}-${per.permissionLevel2Name}`;
    if (!map.get(name2)) {
      map.set(name2, {
        id: name2,
        add_label: per.openStatus === 0 ? `${per.permissionLevel2Name}(未开通)` : per.permissionLevel2Name,
        children: [],
        disabled: per.openStatus === 0,
      });
      level1.children.push(map.get(name2));
    }
    const level2 = map.get(name2);

    if (!per.permissionLevel3Name) {
      level2.children.push(leaf);
      return;
    }

    const name3 = `${name2}-${per.permissionLevel3Name}`;
    if (!map.get(name3)) {
      map.set(name3, {
        id: name3,
        add_label: per.openStatus === 0 ? `${per.permissionLevel3Name}(未开通)` : per.permissionLevel3Name,
        children: [],
        disabled: per.openStatus === 0,
      });
      level2.children.push(map.get(name3));
    }
    const level3 = map.get(name3);
    level3.children.push(leaf);
  });
  return tree;
}
